/** Props from useFormRender that must not be spread onto DOM or Mantine field primitives. */
export function omitFormRenderContext(props = {}) {
  const {
    formMode,
    formAction,
    readonly,
    form,
    ...rest
  } = props;
  return rest;
}
